// Shared Tailwind class strings for the Communication feature, so its pages match
// the rest of the portal (tokens from index.css / tailwind.config.js) and stay
// visually consistent with the shared DataTable / MultiSelectListbox components.
export const ui = {
  pageTitle: 'text-2xl font-bold text-primary',
  sectionCard: 'rounded-lg border border-border-default bg-surface-alt p-5 shadow-sm',
  sectionTitle: 'text-lg font-semibold text-primary',
  label: 'block text-sm font-medium text-secondary mb-1',
  input:
    'w-full rounded-md border border-border-default bg-surface-alt px-3 py-2 text-sm text-primary shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
  control:
    'rounded-md border border-border-default bg-surface-alt px-3 py-2 text-sm text-primary shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500',
  btnPrimary:
    'inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:opacity-50',
  btnSecondary:
    'inline-flex items-center rounded-md border border-border-default bg-surface-alt px-3 py-1.5 text-sm text-secondary hover:bg-surface-hover disabled:opacity-50',
  btnDanger:
    'inline-flex items-center rounded-md border border-red-300 px-3 py-1.5 text-sm text-red-600 hover:bg-red-50 disabled:opacity-50 dark:border-red-800 dark:hover:bg-red-950',
  checkbox: 'h-4 w-4 accent-blue-600',
  tableWrap: 'overflow-x-auto rounded-lg border border-border-default',
  table: 'min-w-full divide-y divide-border-default',
  thead: 'bg-surface',
  th: 'px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-muted',
  tbody: 'divide-y divide-border-default bg-surface-alt',
  td: 'px-4 py-3 text-sm text-secondary',
} as const;
